import React from "react";
import InputData2 from "./inputdata2";
import InputData1 from "./inputdata1";
import InputData3 from "./inputdata3";

export default function InputData(){
    return(
        <div className="relative h-full w-full bg-[#F1F2F3] py-10">
          {/* Blurry Background */}
          <div className="absolute top-0 right-0 w-[20vw] h-[20vw] bg-red-100 opacity-50 blur-md rounded-full pointer-events-none rounded-tl-none rounded-tr-none rounded-br-none z-0"></div>
             <div className="relative">
                {/* <InputData1/>       */}
                <InputData2/>
                <InputData3/>
            </div>
        </div>
    )
}